import React, {useState, useEffect} from 'react';
import {
  Grid,
  Avatar,
  Typography,
  makeStyles,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
  ListItemIcon,
  ListItemSecondaryAction,
  IconButton,
  Popover,
} from '@material-ui/core';
import {AccountBalance} from '@material-ui/icons';

import {Link} from 'react-router-dom';
import MenuIcon from '@material-ui/icons/MoreVert';
import api from '../core/api';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import {useSnackbar} from 'notistack';
import Confirm from './Confirm';
import {useAppContext} from './singletons/AppContext';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
  typography: {
    padding: theme.spacing(2),
  },
}));

const BusinessItem = ({business}) => {
  const {enqueueSnackbar} = useSnackbar();
  const {onReloadData} = useAppContext();

  const onDeleteBusiness = async () => {
    return;
    const res = await Confirm('Deseja realmente remover esta business?');
    if (res) {
      try {
        await api.delete(`/business/${business.id}`);
        onReloadData();
        enqueueSnackbar('Deletado com Sucesso!');
      } catch (e) {
        console.log(e);
      }
    }
  };

  const initialLetter = business.tradeName || '';

  return (
    <React.Fragment>
      <ListItem alignItems="center">
        <ListItemAvatar>
          <Avatar src="" alt="Remy Sharp" style={{textTransform: 'uppercase'}}>
            {business && initialLetter[0]}
          </Avatar>
        </ListItemAvatar>

        <ListItemText
          primary={business.tradeName}
          secondary={
            <Grid container>
              {/* <Grid item xs={5}>
                <ListItemIcon>
                  <AccountBalance />
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    {business.corporateName}
                  </Typography>
                </ListItemIcon>
              </Grid> */}
              <Grid item xs={1}>
                <ListItemIcon>
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    Código cliente: {business.clientCode}
                  </Typography>
                </ListItemIcon>
              </Grid>
              <Grid item xs={2}>
                <ListItemIcon>
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    Nome Fantasia: {business.tradeName}
                  </Typography>
                </ListItemIcon>
              </Grid>
              <Grid item xs={2}>
                <ListItemIcon>
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    Razão Social / Nome Completo: {business.corporateName}
                  </Typography>
                </ListItemIcon>
              </Grid>
              <Grid item xs={1}>
                <ListItemIcon>
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    Cidade: {business.city}
                  </Typography>
                </ListItemIcon>
              </Grid>
              <Grid item xs={1}>
                <ListItemIcon>
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    Estado: {business.state}
                  </Typography>
                </ListItemIcon>
              </Grid>
              <Grid item xs={1}>
                <ListItemIcon>
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    Empresa filial: {!!business.is_branch ? 'Sim' : 'Não'}
                  </Typography>
                </ListItemIcon>
              </Grid>
              <Grid item xs={1}>
                <ListItemIcon>
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    Empresa pertencente agrupo:{' '}
                    {!!business.belongs_to_group ? 'Sim' : 'Não'}
                  </Typography>
                </ListItemIcon>
              </Grid>
              <Grid item xs={1}>
                <ListItemIcon>
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    Status do Contrato: {business.contractStatus}
                  </Typography>
                </ListItemIcon>
              </Grid>
              <Grid item xs={1}>
                <ListItemIcon>
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    Vigência do Contrato:{' '}
                    {moment
                      .utc(business.contractValidityDate)
                      .format('DD/MM/YYYY') || '-'}
                  </Typography>
                </ListItemIcon>
              </Grid>
              <Grid item xs={1}>
                <ListItemIcon>
                  <Typography
                    style={{marginLeft: 8}}
                    variant="body2"
                    className="flex-row center-b"
                    color="textPrimary">
                    Status do cliente: {business.clientStatus}
                  </Typography>
                </ListItemIcon>
              </Grid>
            </Grid>
          }
        />
        <ListItemSecondaryAction>
          <IconButton
            component={Link}
            to={`/empresas/edit/${business.id}`}
            edge="end">
            <EditIcon />
          </IconButton>
          {/* <IconButton onClick={onDeleteBusiness} edge="end">
            <DeleteIcon />
          </IconButton> */}
        </ListItemSecondaryAction>
      </ListItem>
      <Divider />
    </React.Fragment>
  );
};
export default BusinessItem;
